module.exports = __webpack_public_path__ + "static/media/007-app.1238a315.svg";